import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.table`
  ${tw`w-full`};

  th {
    ${tw`text-left pb-4`};
    border-bottom: 1px solid var(--color-grey);

    &:last-child {
      ${tw`text-right`};
    }
  }

  td {
    ${tw`py-6`};

    &:last-child {
      ${tw`text-right`};
    }
  }

  tr + tr td {
    border-top: 1px solid var(--color-grey);
  }
`
